import React from 'react';
import ReactDOM from 'react-dom';
import v4 from 'uuid/v4';
import config from '../../utils/config';
import { VATrate } from '../../utils/price_config';
import scriptLoader from 'react-async-script-loader';
import { getUserId } from '../../utils/apputils';
import { paypal as paypalActions } from '../../store/actions';
import { payPalCheckout, payPalSuccess } from '../../utils/google';

class PaypalButton extends React.Component {
  constructor(props) {
    super(props);
    window.React = React;
    window.ReactDOM = ReactDOM;
    this.state = {
      showButton: false
    };
  }

  componentWillReceiveProps({ isScriptLoaded, isScriptLoadSucceed }) {
    const { onError } = this.props;
    if (!this.state.show) {
      if (isScriptLoaded && !this.props.isScriptLoaded) {
        if (isScriptLoadSucceed) {
          this.setState({ showButton: true });
        } else {
          onError();
        }
      }
    }
  }

  componentDidMount() {
    const { isScriptLoaded, isScriptLoadSucceed } = this.props;
    if (isScriptLoaded && isScriptLoadSucceed) {
      this.setState({ showButton: true });
    }
  }

  componentDidUpdate({ creditsPackage: prevCreditsPackage }) {
    const { creditsPackage } = this.props;
    if (prevCreditsPackage !== creditsPackage && this.onChange) {
      // `&& this.onChange` required to prevent race condition re: paypal button validating (`this.validate`)
      // (event listener example: https://developer.paypal.com/demo/checkout/#/pattern/validation)
      this.onChange();
    }
  }

  payment = (data, actions) => {
    payPalCheckout();
    let {
      creditsPackage: { name, price, sku },
      dispatch
    } = this.props;
    if (name !== 'Digital image') name = `${name} Credits`;
    let tax = price * VATrate;
    const total = (price + tax).toFixed(2);
    tax = tax.toFixed(2);
    const uuid = v4();
    const details = {
      payment: {
        intent: 'sale',
        transactions: [
          {
            amount: {
              total,
              currency: 'GBP',
              details: {
                subtotal: price,
                tax,
                shipping: '0.00'
              }
            },
            description: name,
            invoice_number: uuid,
            payment_options: {
              allowed_payment_method: 'INSTANT_FUNDING_SOURCE'
            },
            item_list: {
              items: [
                {
                  name,
                  description: name,
                  quantity: '1',
                  price,
                  tax,
                  sku,
                  currency: 'GBP'
                }
              ]
            }
          }
        ],
        note_to_payer: 'Contact us for any questions on your order.'
      }
    };
    dispatch(paypalActions.paymentPending());
    this.onChange();
    const payment = actions.payment.create(details);
    return payment;
  };

  onAuthorize = async data => {
    const { onPayment } = this.props;
    const url = `${config.APIRoot}images/execute_payment`;
    const userId = await getUserId();
    const body = {
      paymentID: data.paymentID,
      payerID: data.payerID
    };
    if (userId) body.identity_id = userId;
    // eslint-disable-next-line no-undef
    return paypal.request.post(url, body).then(receipt => {
      payPalSuccess(receipt);
      onPayment(receipt);
    });
  };

  onCancel = (data, actions) => {
    const { dispatch } = this.props;
    dispatch(paypalActions.ready());
    this.onChange();
    actions.close();
  };

  onError = error => {
    console.log('onError', error);
  };

  toggleButton = actions => {
    const { creditsPackage, status } = this.props;
    if (creditsPackage !== undefined) {
      creditsPackage.name && status !== paypalActions.types.PAYMENT_PENDING
        ? actions.enable()
        : actions.disable();
    }
  };

  validate = actions => {
    this.toggleButton(actions);

    this.onChange = () => {
      this.toggleButton(actions);
    };
  };

  onClick = () => {
    const { dispatch, creditsPackage, status } = this.props;
    if (creditsPackage !== undefined) {
      const errorMsg = () => {
        if (!creditsPackage.name) {
          return 'Please select a credits package';
        } else if (status === paypalActions.types.PAYMENT_PENDING) {
          return 'The PayPal window is open. Please close it before attempting to checkout again';
        } else return '';
      };

      dispatch(paypalActions.buttonClick(errorMsg()));
    }
  };

  env = process.env.REACT_APP_ENV === 'app' ? 'production' : 'sandbox';

  client = {
    [this.env]: config.paypalClientId
  };

  // https://developer.paypal.com/docs/integration/direct/express-checkout/integration-jsv4/customize-button/#button-styles
  style = {
    color: 'gold',
    shape: 'rect',
    size: 'medium'
  };

  funding = { disallowed: ['credit'] };

  render() {
    const {
      state,
      env,
      client,
      style,
      payment,
      onAuthorize,
      onError,
      onCancel,
      validate,
      onClick,
      funding
    } = this;
    if (state.showButton) {
      return (
        // eslint-disable-next-line react/jsx-no-undef
        <paypal.Button.react
          env={env}
          client={client}
          style={style}
          payment={payment}
          commit={true}
          onAuthorize={onAuthorize}
          onError={onError}
          onCancel={onCancel}
          validate={validate}
          onClick={onClick}
          funding={funding}
        />
      );
    }
    return null;
  }
}

export default scriptLoader('https://www.paypalobjects.com/api/checkout.js')(
  PaypalButton
);



// WEBPACK FOOTER //
// ./src/comps/Feature/PaypalButton.js